/** Gen1TrunkingOrderRepeaterSerials 1 行分のプロパティ名・OperationType 値。 */

/** 行の「入力あり」判定に使うフィールド名 */
export const REPEATER_LINE_INPUT_FIELD_KEYS = [
    'OrderNumber',
    'BaseModel',
    'SerialNumber',
    'ExchangeSystemId',
];

/** 明細行 payload の主要プロパティ名 */
export const REPEATER_LINE_FIELD = {
    LineSequenceNumber: 'LineSequenceNumber',
    OperationType: 'OperationType',
    ExchangePairId: 'ExchangePairId',
    ExchangeSystemId: 'ExchangeSystemId',
    OrderNumber: 'OrderNumber',
    BaseModel: 'BaseModel',
    SerialNumber: 'SerialNumber',
};

export const REPEATER_OPERATION_ADD = 'ADD';
export const REPEATER_OPERATION_REMOVE = 'REMOVE';
